import React from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import './Sidebar.css';
import { getToken, isAdmin } from '../utils/auth';

const NAV_LABELS = {
  home: '홈(건강 기록 분석)',
  reports: '분석 리포트',
  healthDashboard: '건강 대시보드',
  consultationDashboard: '상담 대시보드',
  consultationChat: '상담 채팅',
  reviewQueue: 'Stop the line 리뷰',
  retailIntelligence: '건강 장보기 추천',
  retailConsole: '리테일 검증 콘솔',
  retailAdmin: '리테일 관리',
  identity: 'Identity 콘솔',
  gatewayTrace: 'Gateway Trace',
  icsn: 'iCSN 콘솔',
};

const USER_SHELL_PATH_PREFIXES = ['/consult/chat'];

function Sidebar({
  isOpen,
  closeMenu,
  context,
  showSmartHealingAction = false,
  onSmartHealingClick,
  smartHealingLoading = false,
  smartHealingLabel = '스마트힐링',
}) {
  const location = useLocation();
  const isLoggedIn = (context && context.isLoggedIn !== undefined)
    ? context.isLoggedIn
    : !!getToken();
  const isUserShellPath = USER_SHELL_PATH_PREFIXES.some((prefix) => (
    location.pathname === prefix || location.pathname.startsWith(`${prefix}/`)
  ));
  const admin = !isUserShellPath && Boolean(context?.isAdmin || isAdmin());

  return (
    <div className={`sidebar ${isOpen ? 'open' : ''}`}>
      <div className="sidebar-header">
        <button type="button" onClick={closeMenu} className="close-button">
          &times;
        </button>
      </div>

      <nav className="sidebar-nav">
        <NavLink to="/" className={`nav-item ${!isLoggedIn ? 'disabled' : ''}`} onClick={closeMenu}>
          {NAV_LABELS.home}
        </NavLink>
        <NavLink
          to="/reports"
          className={`nav-item ${!isLoggedIn ? 'disabled' : ''}`}
          onClick={closeMenu}
        >
          {NAV_LABELS.reports}
        </NavLink>
        <NavLink
          to="/analysis/dashboard"
          className={`nav-item ${!isLoggedIn ? 'disabled' : ''}`}
          onClick={closeMenu}
        >
          {NAV_LABELS.healthDashboard}
        </NavLink>
        {showSmartHealingAction ? (
          <button
            type="button"
            className="nav-item nav-button"
            onClick={onSmartHealingClick}
            disabled={smartHealingLoading}
          >
            {smartHealingLabel}
          </button>
        ) : null}
        <NavLink
          to="/consultation"
          className={`nav-item ${!isLoggedIn ? 'disabled' : ''}`}
          onClick={closeMenu}
        >
          {NAV_LABELS.consultationDashboard}
        </NavLink>
        <NavLink
          to="/consult/chat"
          className={`nav-item ${!isLoggedIn ? 'disabled' : ''}`}
          onClick={closeMenu}
        >
          {NAV_LABELS.consultationChat}
        </NavLink>
        {admin ? (
          <NavLink
            to="/review"
            className={`nav-item ${!isLoggedIn ? 'disabled' : ''}`}
            onClick={closeMenu}
          >
            {NAV_LABELS.reviewQueue}
          </NavLink>
        ) : null}
        {isLoggedIn ? (
          <NavLink
            to="/retail-intelligence"
            className={`nav-item ${!isLoggedIn ? 'disabled' : ''}`}
            onClick={closeMenu}
          >
            {NAV_LABELS.retailIntelligence}
          </NavLink>
        ) : null}
        {admin ? (
          <NavLink
            to="/console/retail-intelligence"
            className={`nav-item ${!isLoggedIn ? 'disabled' : ''}`}
            onClick={closeMenu}
          >
            {NAV_LABELS.retailConsole}
          </NavLink>
        ) : null}
        {admin ? (
          <NavLink
            to="/console/retail-intelligence/admin"
            className={`nav-item ${!isLoggedIn ? 'disabled' : ''}`}
            onClick={closeMenu}
          >
            {NAV_LABELS.retailAdmin}
          </NavLink>
        ) : null}
        {admin ? (
          <NavLink
            to="/console/identity"
            className={`nav-item ${!isLoggedIn ? 'disabled' : ''}`}
            onClick={closeMenu}
          >
            {NAV_LABELS.identity}
          </NavLink>
        ) : null}
        {admin ? (
          <NavLink
            to="/console/gateway-trace"
            className={`nav-item ${!isLoggedIn ? 'disabled' : ''}`}
            onClick={closeMenu}
          >
            {NAV_LABELS.gatewayTrace}
          </NavLink>
        ) : null}
        {admin ? (
          <NavLink
            to="/console/icsn"
            className={`nav-item ${!isLoggedIn ? 'disabled' : ''}`}
            onClick={closeMenu}
          >
            {NAV_LABELS.icsn}
          </NavLink>
        ) : null}
      </nav>
    </div>
  );
}

export default Sidebar;
